import { environment } from '@/constants/environment'

let mouseflowLoaded = false

/**
 * Dynamically loads the Mouseflow analytics script if the campaign has it enabled.
 */
export function loadMouseflowScript(websiteId: string): void {
  if (mouseflowLoaded || !websiteId) {
    return
  }
  mouseflowLoaded = true
  ;(window as any)._mfq = (window as any)._mfq || []
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.defer = true
  script.src = `//cdn.mouseflow.com/projects/${websiteId}.js`
  document.head.appendChild(script)
}

/**
 * Initializes Mouseflow when the campaign opts in. The project id comes from
 * VITE_MOUSEFLOW_PROJECT_ID (set in production only); the campaign payload only
 * carries the mouseflow_enabled flag. With no id configured, loadMouseflowScript no-ops.
 */
export function initMouseflowFromCampaign(campaign: any): void {
  if (campaign?.mouseflow_enabled) {
    loadMouseflowScript(environment.thirdParty.mouseflowProjectId)
  }
}

/**
 * Tags the current Mouseflow session with key-value data.
 */
export function tagMouseflowSession(key: string, value: string): void {
  const mfq = (window as any)._mfq
  if (mfq) {
    mfq.push(['tag', key, value])
  }
}

/**
 * Stops Mouseflow recording to prevent capturing sensitive PII on screens
 * like customer match / verify.
 */
export function stopMouseflowRecording(): void {
  const mfq = (window as any)._mfq
  if (mfq) {
    mfq.push(['stop'])
  }
}

/**
 * Resumes Mouseflow recording after a previously issued stop.
 */
export function startMouseflowRecording(): void {
  const mfq = (window as any)._mfq
  if (mfq) {
    mfq.push(['start'])
  }
}

export function setMouseflowVariable(key: string, value: string | number): void {
  const mfq = (window as any)._mfq
  if (mfq) {
    mfq.push(['setVariable', key, String(value)])
  }
}

export function emitMouseflowPageView(path: string): void {
  const mfq = (window as any)._mfq
  if (mfq) {
    mfq.push(['newPageView', path])
  }
}
